




























import { Component, Vue, Prop } from 'vue-property-decorator';
import Animation from '@getaccept/lib-shared/src/components/Animation.vue';

@Component({
  components: {
    Animation,
  },
})
export default class SignConfirmation extends Vue {
  @Prop() hideBorderRadius: boolean;
  @Prop() shouldPopStripe: boolean;
  animationDelay = 1000;

  handleAnimationLoaded(animation: any) {
    setTimeout(() => {
      animation.play();
    }, this.animationDelay);
  }
}
